"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alert = Alert;
exports.AlertAction = AlertAction;
exports.AlertDescription = AlertDescription;
exports.AlertTitle = AlertTitle;
var React = _interopRequireWildcard(require("react"));
var _classVarianceAuthority = require("class-variance-authority");
var _utils = require("@design/lib/utils");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "variant", "fill"],
  _excluded2 = ["className"],
  _excluded3 = ["className"],
  _excluded4 = ["className"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var alertVariants = (0, _classVarianceAuthority.cva)("group/alert relative grid w-full gap-0.5 rounded-lg border bg-card p-4 text-left text-sm has-data-[slot=alert-action]:relative has-data-[slot=alert-action]:pr-18 has-[>svg]:grid-cols-[auto_1fr] has-[>svg]:gap-x-3 *:[svg]:row-span-2 *:[svg]:translate-y-0.5 *:[svg]:text-current *:[svg:not([class*='size-'])]:size-4", {
  variants: {
    variant: {
      default: "border-border-default text-card-foreground",
      destructive: "border-destructive-border text-destructive-text",
      success: "border-success-border text-success-text",
      warning: "border-warning-border text-warning-text",
      info: "border-info-border text-info-text"
    },
    fill: {
      true: ""
    }
  },
  compoundVariants: [{
    variant: "destructive",
    fill: true,
    className: "bg-destructive-bg"
  }, {
    variant: "success",
    fill: true,
    className: "bg-success-bg"
  }, {
    variant: "warning",
    fill: true,
    className: "bg-warning-bg"
  }, {
    variant: "info",
    fill: true,
    className: "bg-info-bg"
  }],
  defaultVariants: {
    variant: "default"
  }
});
function Alert(_ref) {
  var className = _ref.className,
    variant = _ref.variant,
    fill = _ref.fill,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    "data-slot": "alert",
    role: "alert",
    className: (0, _utils.cn)(alertVariants({
      variant: variant,
      fill: fill
    }), className)
  }, props), {}, {
    "data-sentry-component": "Alert",
    "data-sentry-source-file": "alert.tsx"
  }));
}
function AlertTitle(_ref2) {
  var className = _ref2.className,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    "data-slot": "alert-title",
    className: (0, _utils.cn)("font-medium group-has-[>svg]/alert:col-start-2 [&_a]:underline [&_a]:underline-offset-3 [&_a]:hover:text-foreground", className)
  }, props), {}, {
    "data-sentry-component": "AlertTitle",
    "data-sentry-source-file": "alert.tsx"
  }));
}
function AlertDescription(_ref3) {
  var className = _ref3.className,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    "data-slot": "alert-description",
    className: (0, _utils.cn)("text-sm text-balance text-muted-foreground md:text-pretty [&_a]:underline [&_a]:underline-offset-3 [&_a]:hover:text-foreground [&_p:not(:last-child)]:mb-4", className)
  }, props), {}, {
    "data-sentry-component": "AlertDescription",
    "data-sentry-source-file": "alert.tsx"
  }));
}
function AlertAction(_ref4) {
  var className = _ref4.className,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    "data-slot": "alert-action",
    className: (0, _utils.cn)("absolute top-2.5 right-3", className)
  }, props), {}, {
    "data-sentry-component": "AlertAction",
    "data-sentry-source-file": "alert.tsx"
  }));
}